export const FeatureCode = {
  // STARTER+
  AttendanceRules:          'ATTENDANCE_RULES',
  AttendanceRegularization: 'ATTENDANCE_REGULARIZATION',

  // PRO+
  ShiftManagement:          'SHIFT_MANAGEMENT',
  RosterPlanning:           'ROSTER_PLANNING',
  AttendanceAnalytics:      'ATTENDANCE_ANALYTICS',
  SalaryRevision:           'SALARY_REVISION',
  FinalSettlement:          'FINAL_SETTLEMENT',
  ProvidentFund:            'PROVIDENT_FUND',
  Loans:                    'LOANS',
  Reimbursements:           'REIMBURSEMENTS',
  SmtpOAuthConfig:          'SMTP_OAUTH_CONFIG',
  SsoOAuth:                 'SSO_OAUTH',
  FullAuditLogs:            'FULL_AUDIT_LOGS',
  WorkflowAutomation:       'WORKFLOW_AUTOMATION',
  ExecutiveDashboard:       'EXECUTIVE_DASHBOARD',
  PayrollAnalytics:         'PAYROLL_ANALYTICS',
  RecruitmentAnalytics:     'RECRUITMENT_ANALYTICS',
  PerformanceAnalytics:     'PERFORMANCE_ANALYTICS',

  // ENTERPRISE
  MeritMatrix:              'MERIT_MATRIX',
  TeamsIntegration:         'TEAMS_INTEGRATION',
  ClientPortal:             'CLIENT_PORTAL',
  RestApiAccess:            'REST_API_ACCESS',
  AdvancedRbac:             'ADVANCED_RBAC',
} as const;

export type FeatureCodeType = typeof FeatureCode[keyof typeof FeatureCode];
